$(document).ready(function () {
    $('.recommended-articles.module').each(function () {
        var $section = $(this);
        var $grid = $section.find('.article-card-grid');
        var $moreBtn = $section.find('.recommended-articles__button-more');
        var $lessBtn = $section.find('.recommended-articles__button-less');

        $moreBtn.on('click', function () {
            $grid.removeClass('article-card-grid--show-less').addClass('article-card-grid--show-all');
            $moreBtn.hide();
            $lessBtn.show();
        });

        $lessBtn.on('click', function () {
            var lessBtnPosition = $lessBtn.offset().top - $(window).scrollTop();

            $grid.removeClass('article-card-grid--show-all').addClass('article-card-grid--show-less');
            $lessBtn.hide();
            $moreBtn.show();

            setTimeout(function () { // wait for DOM update
                // scroll page so that more button is in the same position as less button was
                var newScrollPosition = $moreBtn.offset().top - lessBtnPosition;
                window.scrollTo(0, newScrollPosition);
            }, 0);
        });
    });
});
